import React, { useEffect } from "react";
import { useDteSystem } from "../../hooks/dte/useDteSystem";

import DteSystemStatusHeader from "./DteSystemStatusHeader";
import DteSystemStatusOverview from "./DteSystemStatusOverview";
import DteSystemStatusControls from "./DteSystemStatusControls";

const DteSystemStatusPanel: React.FC = () => {
  const { form, isLoading, isSubmitting, loadStatus, enableContingency, disableContingency } =
    useDteSystem();

  useEffect(() => {
    loadStatus();
  }, []);

  const onEnable = async (reason: string) => {
    await enableContingency({ reason, user: "Admin" });
  };

  const onDisable = async () => {
    await disableContingency({ user: "Admin" });
  };

  return (
    <div className="space-y-8 p-6">
      <DteSystemStatusHeader />
      <DteSystemStatusOverview form={form} />
      <DteSystemStatusControls
        manualContingencyEnabled={!!form?.manualContingencyEnabled}
        isSubmitting={isSubmitting}
        isLoading={isLoading}
        onEnable={onEnable}
        onDisable={onDisable}
      />
    </div>
  );
};

export default DteSystemStatusPanel;
